var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSegments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_0_126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.02083C0 0.779209 0.195875 0.583333 0.4375 0.583333H8.02083C8.26246 0.583333 8.45833 0.779209 8.45833 1.02083C8.45833 1.26246 8.26246 1.45833 8.02083 1.45833H0.4375C0.195875 1.45833 0 1.26246 0 1.02083ZM0 12.9792C0 12.7375 0.195875 12.5417 0.4375 12.5417H8.02083C8.26246 12.5417 8.45833 12.7375 8.45833 12.9792C8.45833 13.2208 8.26246 13.4167 8.02083 13.4167H0.4375C0.195875 13.4167 0 13.2208 0 12.9792ZM0.4375 3.35417C0.195875 3.35417 0 3.55004 0 3.79167C0 4.03329 0.195875 4.22917 0.4375 4.22917H13.125V9.77083H0.4375C0.195875 9.77083 0 9.96671 0 10.2083C0 10.45 0.195875 10.6458 0.4375 10.6458H13.5625C13.8041 10.6458 14 10.45 14 10.2083V3.79167C14 3.55004 13.8041 3.35417 13.5625 3.35417H0.4375Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSegments);
export default __webpack_public_path__ + "static/media/iconSegments.14cbb6708ad0699021e4f62a841f57b0.svg";
export { ForwardRef as ReactComponent };